export default __webpack_public_path__ + "static/media/one.17785b19.jpeg";